// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b8422dd5","453":"2912a676","732":"3e695185"}[chunkId] + ".chunk.js";
};